module.exports = __webpack_public_path__ + "img/img22.c7db3dca.svg";